import { CONTACT_EMAIL } from '../lib/site';

export default function PrivacyPolicy() {
  return (
  <div className="max-w-3xl mx-auto py-12 text-text-main">
    <h1 className="font-serif text-4xl md:text-5xl mb-12 tracking-wide">Privacy- en Cookieverklaring – Project LEO</h1>
    
    <div className="space-y-8 text-secondary font-light leading-relaxed">
      <p>Dit is de privacy- en cookieverklaring van Project LEO, beheerd door Blueprint Development. Wij dragen zorg voor de privacy van onze websitebezoekers en gaan zorgvuldig om met je persoonsgegevens conform de Algemene Verordening Gegevensbescherming (AVG/GDPR).</p>

      <h2 className="font-serif text-2xl text-text-main mt-10">1. Contactgegevens</h2>
      <p>
        Project LEO<br/>
        Kruishofstraat 32<br/>
        2020 Antwerpen<br/>
        België<br/>
        BTW: BE 1009.188.196<br/>
        E-mail: <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary hover:underline">{CONTACT_EMAIL}</a>
      </p>

      <h2 className="font-serif text-2xl text-text-main mt-10">2. Welke gegevens verzamelen wij?</h2>
      <p>Wanneer je onze website bezoekt of contact met ons opneemt, kunnen wij de volgende gegevens verwerken:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li><strong>Identificatiegegevens:</strong> Naam en e-mailadres (indien je een contactformulier invult).</li>
        <li><strong>Technische gegevens:</strong> IP-adres, browsertype en apparaatgegevens.</li>
        <li><strong>Gebruiksgegevens:</strong> Informatie over hoe je onze website gebruikt en welke pagina's je bezoekt.</li>
        <li><strong>Campagnegegevens:</strong> De campagne-informatie in de link waarmee je op onze website kwam (zoals utm-waarden en het klik-ID van Google Ads). Wanneer je het contactformulier invult, bewaren we die samen met je aanvraag om te weten via welke advertentie je ons gevonden hebt.</li>
      </ul>

      <h2 className="font-serif text-2xl text-text-main mt-10">3. Waarom verzamelen wij deze gegevens?</h2>
      <p>Wij gebruiken deze informatie op basis van de volgende rechtsgronden:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li><strong>Toestemming:</strong> Voor het plaatsen van niet-essentiële cookies.</li>
        <li><strong>Gerechtvaardigd belang:</strong> Om de veiligheid, stabiliteit en goede werking van de website te garanderen.</li>
        <li><strong>Uitvoering van een overeenkomst:</strong> Om contact met je op te nemen en onze diensten te leveren indien je hierom vraagt.</li>
      </ul>

      <h2 className="font-serif text-2xl text-text-main mt-10">4. Cookies</h2>
      <p>Onze website maakt gebruik van cookies. Bij je eerste bezoek vragen wij toestemming via een cookiebanner.</p>
      <ul className="list-disc pl-5 space-y-2">
        <li><strong>Functionele cookies:</strong> Noodzakelijk voor de werking van de website.</li>
        <li><strong>Analytische cookies:</strong> Om (anoniem) het bezoek aan de website te meten en de gebruikerservaring te verbeteren.</li>
        <li><strong>Marketing cookies:</strong> Enkel indien je hier expliciet toestemming voor geeft.</li>
      </ul>
      <p>Je kunt je browserinstellingen aanpassen om cookies te weigeren of te verwijderen.</p>

      <h2 className="font-serif text-2xl text-text-main mt-10">5. Bewaartermijn</h2>
      <p>Project LEO bewaart je gegevens niet langer dan strikt noodzakelijk. Gegevens via het contactformulier worden maximaal 2 jaar bewaard, tenzij er een wettelijke verplichting is om deze langer te bewaren.</p>

      <h2 className="font-serif text-2xl text-text-main mt-10">6. Delen met derden</h2>
      <p>Wij verkopen jouw gegevens nooit aan derden. Wij delen enkel gegevens met verwerkers die noodzakelijk zijn voor onze dienstverlening (zoals onze hostingprovider), en enkel onder strikte verwerkersovereenkomsten.</p>

      <h2 className="font-serif text-2xl text-text-main mt-10">7. Jouw rechten</h2>
      <p>Je hebt conform de AVG het recht om:</p>
      <ul className="list-disc pl-5 space-y-2">
        <li>Jouw gegevens in te zien, te corrigeren of te laten wissen.</li>
        <li>Bezwaar te maken tegen de verwerking.</li>
        <li>Gegevensoverdraagbaarheid aan te vragen.</li>
      </ul>
      <p>Neem hiervoor contact op via <a href={`mailto:${CONTACT_EMAIL}`} className="text-primary hover:underline">{CONTACT_EMAIL}</a>.</p>

      <h2 className="font-serif text-2xl text-text-main mt-10">8. Klachten</h2>
      <p>Heb je een klacht over onze gegevensverwerking? Dan hopen we dat je eerst contact met ons opneemt. Je hebt echter ook het recht om een klacht in te dienen bij de Belgische toezichthouder:</p>
      <p>
        Gegevensbeschermingsautoriteit (GBA)<br/>
        Drukpersstraat 35, 1000 Brussel
      </p>
    </div>
  </div>
  );
}
